class ReviewsIoProductWidgetHeader extends HTMLElement {
	render({ reviewsCount, averageRating, attributes = [], photoReviews = [] }) {
		const s = window.themeVariables.strings.reviewsIo;
		const averageRatingFloat = parseFloat(averageRating);
		const averageRatingThreshold = parseFloat(this.getAttribute('average-rating-threshold') || '4.5');
		const carouselId = `widget-photo-carousel-${Math.random().toString(36).slice(2, 8)}`;

		const attrsHtml = attributes
			.map((attr) => {
				const percent = ((parseFloat(attr.average_rating) - 1) / 4) * 100;
				const optionsHtml = attr.options.map((o) => `<span>${o}</span>`).join('');
				return `
				<div class="widget-header__attr">
					<p class="widget-header__attr-label">${attr.question}</p>
					<div class="widget-header__attr-track">
						<div class="widget-header__attr-thumb" style="left:${percent}%"></div>
					</div>
					<div class="widget-header__attr-options">${optionsHtml}</div>
				</div>`;
			})
			.join('');

		const photosHtml = photoReviews
			.map((review) => {
				const src = review.photos[0];
				const name = review.author?.name || '';
				const rating = review.rating || 0;
				return `
				<div class="widget-header__photo-item">
					<img src="${src}" alt="${s.customerPhotoBy.replace('{{ name }}', name)}" loading="lazy" width="120" height="120">
					<div class="widget-header__photo-overlay" aria-hidden="true">
						<rating-stars rating="${rating}"></rating-stars>
						<span class="widget-header__photo-name">${name}</span>
					</div>
				</div>`;
			})
			.join('');

		const photoCarouselHtml = photosHtml
			? `<div class="floating-controls-container widget-header__carousel-container">
					<carousel-prev-button class="floating-controls__control" aria-controls="${carouselId}">
						<button disabled class="circle-button" aria-label="${s.previousPhoto}">
							<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M9 1L3 7L9 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
						</button>
					</carousel-prev-button>
					<scroll-carousel id="${carouselId}" class="widget-header__photo-carousel scroll-area" role="region" aria-label="${s.customerPhotos}">
						${photosHtml}
					</scroll-carousel>
					<carousel-next-button class="floating-controls__control" aria-controls="${carouselId}">
						<button class="circle-button" aria-label="${s.nextPhoto}">
							<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M5 1L11 7L5 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
						</button>
					</carousel-next-button>
				</div>`
			: '';

		const formattedCount = reviewsCount?.toLocaleString(Shopify.locale || 'de');
		this.innerHTML = `
			<div class="widget-header__top">
				<div class="widget-header__rating">
					<div class="widget-header__rating-row"${averageRatingFloat >= averageRatingThreshold ? '' : 'hidden'}>
						<span class="widget-header__average">${averageRating}</span>
						<rating-stars class="widget-header__stars" rating="${averageRating}"></rating-stars>
					</div>
					<p class="widget-header__count">${s.basedOnReviews.replace('{{ count }}', formattedCount)}</p>
				</div>
				<div class="widget-header__attrs">${attrsHtml}</div>
			</div>
			${photoCarouselHtml}
			<div class="widget-header__title-row">
				<span class="widget-header__title">${s.productReviews}</span>
			</div>`;
	}
}

if (!customElements.get('reviews-io-product-widget-header')) {
	customElements.define('reviews-io-product-widget-header', ReviewsIoProductWidgetHeader);
}
